interface Config {
    apiUrl: string;
}

// AP API calls are proxied through Express at /api/ap to avoid CORS and keep
// the upstream URL server-side. REACT_APP_BACKEND_API_URL is empty in Docker
// (same origin) and http://localhost:3001 for local non-Docker dev.
const backendUrl = process.env.REACT_APP_BACKEND_API_URL ?? 'http://localhost:3001';

const config: Config = {
    apiUrl: `${backendUrl}/api/ap`,
};

export default config;
